
//components
import { Container, Infos, IntraContainer, Quantity } from "./styles";
import { CloseButton } from "../CloseButton";

//utils
import { formatter } from "../../Utils";

//context
import { useHabUnits } from "../../Providers/HabUnit";

//interfaces
import { IHU, IProductHU, IServiceHU } from "../../Interfaces";
import { useUser } from "../../Providers/User";
interface ICardProductOrServiceHUProps {
  data: IProductHU | IServiceHU;
  HU: IHU;
  type: "product" | "service";
}

export const CardProductOrServiceHU = ({
  data,
  HU,
  type,
}: ICardProductOrServiceHUProps) => {
  const { title, price, quantity } = data;
  const { removeProduct, removeService } = useHabUnits();
  const { admAuth } = useUser();

  return (
    <Container>
      <IntraContainer>
        <Infos>
          <div>{title}</div>
          <div>{formatter.format(price * quantity).padStart(23, ".")}</div>
        </Infos>
        {type === "product"
          ? admAuth && (
              <CloseButton
                deleteProductOrService={removeProduct}
                productOrServiceToBeRemoved={data}
                HU={HU}
              />
            )
          : admAuth && (
              <CloseButton
                deleteProductOrService={removeService}
                productOrServiceToBeRemoved={data}
                HU={HU}
              />
            )}
      </IntraContainer>
      <Quantity>{quantity}x</Quantity>
    </Container>
  );
};
